import { finish, error } from '../../../modules/customers/actions/add-freebet-credit';
import { request as getFreebetCredits } from '../../../modules/customers/actions/get-freebet-credits';

import api from '../../../api';

export function request( dispatch, { customerId, data } ) {
    api.post( `/user/freebet/${customerId}/add`, Object.assign( {}, data, { enabled: true } ) ).then(
        credit => {
            dispatch( finish( customerId, credit ) );
            dispatch( getFreebetCredits( customerId ) );
        },
        ( { errors } ) => dispatch( error( customerId, errors ) )
    );
}
